import { SxProps } from '@mui/material';
import TreeItem, {
  SelectHandler,
} from '@views/Project/components/ScopeFilterModal/TreeItem';
import { ITreeItem } from '@views/Project/helpers';

/**
 * Recursive domain-tree renderer shared by the Scope filter modal and the
 * entity-drawer Domain dropdown. Each item reports the ids of its ancestors
 * alongside its own on select, so the handler can act on the branch without
 * walking the tree again.
 */
export const renderTree = (
  nodes: ITreeItem,
  parentsId: string[],
  onSelect: SelectHandler,
  onClick: (nodeId: string) => void,
  isDisabled?: (id: string) => boolean,
  sx?: SxProps,
) => (
  <TreeItem
    key={nodes.id}
    nodeId={nodes.id}
    label={nodes.name}
    onSelect={({ nodeId, checked }) => onSelect({ nodeId, checked, parentsId })}
    onClick={() => onClick(nodes.id)}
    hasChildren={!!nodes.children?.length}
    disabled={isDisabled?.(nodes.id)}
    sx={sx}
  >
    {nodes.children?.map((item) =>
      renderTree(
        item,
        [...parentsId, nodes.id],
        onSelect,
        () => onClick(item.id),
        isDisabled,
        sx,
      ),
    )}
  </TreeItem>
);
